let sessionToken;
let sessionEpoch = 0;
export function resetStatisticsSession() { sessionToken = undefined; sessionEpoch += 1; }
export function statisticsSession(token) {
  if (sessionToken !== token) { sessionToken = token; sessionEpoch += 1; }
  return sessionEpoch;
}
// Daily reports and private cost snapshots; operational policy reads keep their own freshness.
export const DAILY_STATISTICS_OPTIONS = {
  staleTime: 15 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: false,
};
export const operationalPollingOptions = interval => ({
  refetchInterval: query => query.state.status === 'error' ? false : interval,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: query => query.state.status !== 'error',
  refetchOnReconnect: query => query.state.status !== 'error',
  retry: false,
});
